"use client";
import { createClient } from "@supabase/supabase-js";
import CONSTS from "./consts";

const supabaseUrl = CONSTS.SUPABASE_URL;
const supabaseAnonKey = CONSTS.SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
